<script setup lang="ts">
import { toRef } from "vue";
import { boolean, object } from "yup";

defineOptions({
    inheritAttrs: false,
});
const props = defineProps({
    type: {
        type: String,
        default: "text",
        required: false,
    },
    value: {
        type: [String, null],
        default: "",
    },
    modelValue: {
        type: [String, null],
        default: "",
    },
    name: {
        type: String,
        required: true,
    },

    error: {
        type: String,
        default: null,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    placeholder: {
        type: String,
        default: "",
    },
    maxLength: {
        type: Number,
        default: null,
    },
});

const emit = defineEmits(["update:modelValue"]);

const name = toRef(props, "name");
</script>

<template>

    <input :name="name"
        :id="name"
        :type="type"
        :value="props.modelValue"
        class="form-control rounded "
        :class="{ 'is-invalid': !!error}"
        :disabled="disabled"
        :placeholder="placeholder"
        @input="emit('update:modelValue', $event.target.value)" />
    <span class="invalid-feedback"
        role="alert"
        v-if="error">
        {{ error}}
    </span>

</template>
